import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function ContractSignedSuccess() {
  const { token } = useParams();
  return (
    <div className="min-h-screen bg-[#041f1b] grid place-items-center px-4">
      <div className="max-w-md text-center" data-testid="contract-signed-success">
        <CheckCircle2 className="text-emerald-400 mx-auto" size={48} />
        <h1 className="mt-6 font-display text-3xl text-[#fdfbf7]">Obrigado!</h1>
        <p className="mt-3 text-sm text-[#a0b2af] leading-relaxed">
          O seu contrato foi assinado com sucesso. Acabámos de lhe enviar uma cópia em PDF por email.
          Pode consultar todos os seus contratos a qualquer momento na sua{" "}
          <Link to="/login" className="text-[#d4af37] hover:underline">área de cliente</Link>.
        </p>
        <Link to="/"
              className="mt-8 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md text-xs font-semibold uppercase tracking-widest bg-[#d4af37] text-[#041f1b] hover:bg-[#e8c860] transition-all">
          Voltar à home
        </Link>
      </div>
    </div>
  );
}
